import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[xmEscKey]',
    standalone: false
})
export class XmEscKey {
    @Output() public escKeyPressed: EventEmitter<void> = new EventEmitter<void>();

    constructor() {}

    @HostListener('document:keydown', ['$event'])

    public handleKeyboardEvent(event: KeyboardEvent): void {
        if (event.key === 'Escape') {
            this.escKeyPressed.emit();
        }
    }
}
